import React from "react";
import { Link } from "react-router-dom";
import backgroundImage from "../../assets/program-img3.jpg";
function HistorySection() {
  return (
    <section
      className="history-section flex items-center justify-center min-h-[60vh] sm:min-h-[70vh] md:min-h-[80vh] bg-cover bg-center bg-opacity-50 relative"
      style={{
        backgroundImage: `url(${backgroundImage})`,
      }}
    >
      {/* Overlay for background image opacity */}
      <div className="absolute inset-0 bg-black opacity-50"></div>

      <div className="relative z-10 text-center p-6 sm:p-10 md:p-16 lg:p-20 xl:p-24 bg-white bg-opacity-80 rounded-lg shadow-lg w-full max-w-6xl mx-4 my-8 sm:my-12 md:my-16">
        <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-custom-pink mb-6">
          FROM ROOTS TO REACH OUR JOURNEY IN IT EDUCATION
        </h1>
        <span className="inline-block border-solid  border-b-4 border-gold mb-4 w-28 h-2"></span>

        <p className="text-base sm:text-lg text-gray-800 tracking-wide w-full max-w-[900px] text-justify mx-auto leading-relaxed mb-6 px-4">
          JR Institute of Information technology (JRIIT) history is traced back
          to 1999 when JR Electronics LTD, a company dealing with IT
          communication and network branched itself to give a start to an
          education entity called JR Institute of Information Technology
          (JRIIT). Initially, JRIIT’s scope of action was limited to training
          the workers (and candidates for employment) of the parental company.
          But soon JRIIT transformed itself into a fully Educational Institute
          embracing more local young people who were eager to learn new IT
          skills.
        </p>

        {/* Buttons */}
        <div className="flex flex-wrap justify-center gap-4 sm:gap-6 mt-6 sm:mt-8">
          <Link
            to="/about"
            className="bg-none border border-custom-pink text-custom-pink py-2 sm:py-3 px-4 sm:px-6 md:px-8 lg:px-10 xl:px-20 hover:text-white rounded-full hover:bg-custom-pink"
          >
            OUR HISTORY
          </Link>
          <Link
            to="/about/mission"
            className="bg-none border border-custom-pink text-custom-pink py-2 sm:py-3 px-4 sm:px-6 md:px-8 lg:px-10 xl:px-20 hover:text-white rounded-full hover:bg-custom-pink"
          >
            OUR MISSION
          </Link>
          <Link
            to="/about/trustees"
            className="bg-none border border-custom-pink text-custom-pink py-2 sm:py-3 px-4 sm:px-6 md:px-8 lg:px-10 xl:px-20 hover:text-white rounded-full hover:bg-custom-pink"
          >
            OUR TEAM
          </Link>
        </div>
      </div>
    </section>
  );
}

export default HistorySection;
